import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const staffApi = axios.create({ baseURL: `${BACKEND_URL}/api/experience` });

staffApi.interceptors.request.use((c) => {
  c.headers["X-API-Key"] = process.env.REACT_APP_API_KEY || "";
  const t = sessionStorage.getItem("ut_staff_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  const d = localStorage.getItem("ut_device_token");
  if (d) c.headers["X-Device-Token"] = d;
  return c;
});

staffApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const u = err.config?.url || "";
    if (err.response?.status === 401 && u.includes("/staff/") && !u.includes("/staff/login")) {
      sessionStorage.removeItem("ut_staff_token");
      sessionStorage.removeItem("ut_staff");
      window.dispatchEvent(new CustomEvent("ut-staff-logout"));
    }
    return Promise.reject(err);
  }
);

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const STATUS_META = {
  waiting_for_waiter: { label: "NEW ORDER", color: "#FF5A4E", bg: "rgba(255,90,78,0.16)" },
  waiter_reviewing: { label: "REVIEWING", color: "#F0B429", bg: "rgba(240,180,41,0.14)" },
  confirmed: { label: "CONFIRMED", color: "#5AB0FF", bg: "rgba(90,176,255,0.14)" },
  pos_failed: { label: "NOT IN KITCHEN", color: "#FF5A4E", bg: "rgba(255,90,78,0.16)" },
  sent_to_pos: { label: "SENT TO KITCHEN", color: "#5AB0FF", bg: "rgba(90,176,255,0.14)" },
  preparing: { label: "PREPARING", color: "#5AB0FF", bg: "rgba(90,176,255,0.14)" },
  ready: { label: "READY", color: "#2ECC71", bg: "rgba(46,204,113,0.16)" },
  served: { label: "SERVED", color: "#3FD8C2", bg: "rgba(63,216,194,0.14)" },
  payment_requested: { label: "PAYMENT", color: "#D4AF37", bg: "rgba(212,175,55,0.16)" },
  paid: { label: "PAID", color: "#2ECC71", bg: "rgba(46,204,113,0.16)" },
  completed: { label: "DONE", color: "#9AA0A6", bg: "rgba(154,160,166,0.12)" },
  cancelled: { label: "CANCELLED", color: "#9AA0A6", bg: "rgba(154,160,166,0.12)" },
};

export const timeSince = (iso) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  return `${Math.floor(m / 60)}h ${m % 60}m ago`;
};

export const alertSound = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    [[660, 0], [880, 0.18], [1100, 0.36]].forEach(([f, at]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "square";
      o.frequency.value = f;
      o.connect(g);
      g.connect(ctx.destination);
      g.gain.setValueAtTime(0.0001, ctx.currentTime + at);
      g.gain.exponentialRampToValueAtTime(0.18, ctx.currentTime + at + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + 0.3);
      o.start(ctx.currentTime + at);
      o.stop(ctx.currentTime + at + 0.35);
    });
    setTimeout(() => ctx.close().catch(() => {}), 1200);
  } catch { /* audio unavailable */ }
};
